 /* window.onload = function() {
      if (window.jQuery) {  
          // jQuery is loaded  
          alert("Yeah!");
      } else {
          // jQuery is not loaded
          alert("Doesn't Work");
      }
  } 
  https://developers.google.com/youtube/iframe_api_reference#Example_Video_Player_Constructors
 
  */ 
  
jQuery(document).ready(function() {
                 
jQuery(".video2").click(function() {
  
        jQuery.fancybox({
            'padding'		: 0,
            'autoScale'		: false,
            'transitionIn'	: 'none',
            'transitionOut'	: 'none',
            'title'			: this.title,
            'width'		    : 900,
            'height'		: 506,
            'href'			: this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
            'type'			: 'iframe',
        });

      /* 
      
       jQuery.fancybox({
            'padding'		: 0,
            'autoScale'		: false,
            'transitionIn'	: 'none',
            'transitionOut'	: 'none',
            'title'			: this.title,
            'width'		    : 900,
            'height'		: 506,
            'href'			: this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
            'type'			: 'swf',
            'swf'			: {
                'wmode'		: 'transparent',
                'allowfullscreen'	: 'true'
            }
        });
        
        
        setTimeout(function() {
             $( "#embed_frame" ).trigger( "click" );
             $( "#fancybox-content object" ).trigger( "click" );
             $( "#player" ).trigger( "click" );
             $("#embed_frame").contents().find(".ytp-cued-thumbnail-overlay-image").click();
             $("#embed_frame").contents().find(".ytp-cued-thumbnail-overlay-image").trigger( "click" );
            jQuery.event.trigger({ type: 'keydown', which: 32 }); 
            jQuery.event.trigger({ type: 'keypress', which: 32 }); 
            alert("i clicked");
        }, 2000);
    */

  
      
       return false;
});

   
});